import React from "react";
import { StyleSheet, View, StyleProp, ViewStyle } from "react-native";

export type ChevronRightIconProps = {
  style?: StyleProp<ViewStyle>;
};

export const ChevronRightIcon: React.FC<ChevronRightIconProps> = ({
  style,
}) => {
  return (
    <View style={[styles.container, style]}>
      <svg width="7.63" height="12.777" viewBox="0 0 7.63 12.777">
        <path
          id="シェイプ_13"
          data-name="シェイプ 13"
          d="M673.474,1210.877a1.133,1.133,0,0,1,.8.333l5.358,5.358a1.136,1.136,0,0,1,0,1.607l-5.147,5.147a1.136,1.136,0,1,1-1.607-1.607l4.344-4.344-4.554-4.554a1.136,1.136,0,0,1,.8-1.94Z"
          transform="translate(-672.338 -1210.877)"
          fill="#a5a5a5"
        />
      </svg>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
});
